import { db } from "../Firebase";

export function GetFirestore(nome: string, setInfo: any) {
    const ref = db.collection(`/${nome}`);
    ref.onSnapshot(e => {
        const dati: any[] = []
        e.forEach(e => { dati.push(e.data()) })
        dati.forEach(e => { setInfo(e) })
    })

}
